var t=(e=>(e.Rounded="rounded",e.Square="square",e))(t||{}),o=(e=>(e.Light="light",e.Bold="bold",e))(o||{}),n=class r{constructor(i){this._isLooping=!1;this._isLooping=i;}get isLooping(){return this._isLooping}static fromJSON(i){return i===null?null:new r(i.looping)}toJSONObject(){return {looping:this.isLooping}}};

export { t as a, o as b, n as c };
